module.exports = __webpack_public_path__ + "static/media/10.4ba32ed8.jpg";